	<div class="inner-page-bg-right">

		<section class="privacy-content">
			<div class="container">
				<div class="privacy-container">
					<h1>Privacy Policy</h1>
					
					<p>Scanfluence ("we", "our", "us") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website, applications, and services ("Services"). By using our Services, you consent to the practices described in this Policy.</p>

					<h2>1. Information We Collect</h2>
					<p><strong>Personal Information:</strong> Name, email address, contact details, payment information, and account credentials provided during registration and use of the Services.</p>
					<p><strong>Usage Data:</strong> Information about your interactions with our Services, including device details, IP address, browser type, operating system, and pages accessed.</p>
					<p><strong>Cookies and Tracking Technologies:</strong> As detailed in our Cookie Policy, we and third-party providers use cookies and similar tracking technologies to enhance user experience, analyze usage, provide targeted advertising, and enable secure payments.</p>

					<h2>2. How We Use Information</h2>
					<ul>
						<li>To provide, operate, and maintain the Services.</li>
						<li>To process transactions and manage billing.</li>
						<li>To improve and personalize your experience.</li>
						<li>To communicate with you regarding updates, support, and promotional offers.</li>
						<li>To comply with legal obligations and enforce our Terms of Service.</li>
					</ul>

					<h2>3. Third-Party Services and Cookies</h2>
					<p>We engage trusted third-party service providers that may collect and process personal information on our behalf, including setting cookies. These include:</p>
					<ul>
						<li>Analytics providers (Google Analytics, Hotjar) for understanding website usage and traffic patterns.</li>
						<li>Advertising partners (Facebook Pixel, LinkedIn Ads) for delivering relevant ads and measuring performance.</li>
						<li>Payment processors (Stripe) for secure checkout and fraud prevention.</li>
					</ul>
					<p>These third parties manage data according to their own privacy and cookie policies, which we encourage you to review.</p>

					<h2>4. Legal Basis for Processing (GDPR Compliance)</h2>
					<p>We process your personal information under the following bases:</p>
					<ul>
						<li>Consent</li>
						<li>Performance of a contract</li>
						<li>Legitimate interests</li>
						<li>Compliance with legal obligations</li>
					</ul>

					<h2>5. Data Sharing and Disclosure</h2>
					<p>We do not sell your personal data. We may share information with:</p>
					<ul>
						<li>Service providers assisting in delivering our Services.</li>
						<li>Law enforcement or regulatory authorities if required by law.</li>
						<li>In connection with mergers, acquisitions, or sale of assets.</li>
					</ul>

					<h2>6. Data Storage and Security</h2>
					<p>We implement administrative, technical, and physical safeguards to protect your data. Data may be stored in locations globally where we or our service providers operate.</p>

					<h2>7. Data Retention</h2>
					<p>We retain personal information as long as necessary to fulfill purposes outlined in this Policy unless a longer retention period is required by law.</p>

					<h2>8. International Data Transfers</h2>
					<p>Your information may be transferred and processed in countries outside your residence. We ensure adequate safeguards (e.g., Standard Contractual Clauses).</p>

					<h2>9. Your Rights</h2>
					<p>Depending on your jurisdiction (GDPR, CCPA), you may have rights to:</p>
					<ul>
						<li>Access, correct, or delete your personal information.</li>
						<li>Object to or restrict processing.</li>
						<li>Withdraw consent at any time.</li>
						<li>Request data portability.</li>
					</ul>
					<p>To exercise these rights, contact us at privacy@scanfluence.com.</p>

					<h2>10. Children's Privacy</h2>
					<p>Our Services are not intended for individuals under 16. We do not knowingly collect personal information from children.</p>

					<h2>11. Changes to This Privacy Policy</h2>
					<p>We may update this Policy periodically. Continued use of Services indicates acceptance of the updated Policy.</p>

					<h2>12. Contact Information</h2>
					<div class="contact-info">
						<p>For privacy-related inquiries:</p>
						<p><strong>Scanfluence Privacy Office</strong><br>
						3600 Steeles Avenue East<br>
						Markham, ON, L3R 9Z7<br>
						Email: privacy@scanfluence.com</p>
					</div>
				</div>
			</div>
		</section>
	</div>